import './placementassistance.css'

function PlacementAssistance(){
    return(
        <div className="placement_assistance-container">
            <h1>100% Placement Assistance</h1>
            <div className="strip-con">
    <p className="strip"></p>
</div>

            <div className="placement_assistance-data">
                <h1 className="placement_assistance-heading">Resume Building</h1>
                <p className="placement_assistance-para">1FIN provides professional guidance to help you create an effective resume to help you create a lasting impression.</p>
               <h1 className="placement_assistance-heading">Career Counselling</h1>
                <p className="placement_assistance-para">We provide career counselling to conducting mock interviews and aptitude tests – we will assist you at every step, all the way, we make you job ready.</p>
                <h1 className="placement_assistance-heading">Jobs</h1>
                <p className="placement_assistance-para">We will give you an edge over others with our direct corporate affiliations which will ensure that you are placed right.</p>
                
            </div>
            </div>
    )
}

export default PlacementAssistance;